module.exports = __webpack_public_path__ + "img/H5_6.d0156038.png";